import instanceAxios from './axiosConfig';
import { URL } from '../utility/util';


const getCCPMetaData = async () => {
    let req = JSON.stringify({
        "method": "getCCPMetaData"
    });
    return new Promise((resolve, reject) => {
        instanceAxios.post('/mso-chat', req)
            .then((response) => {
                if(response.status === 200) {
                    resolve(response.data)
                }else{
                    reject("Data not found")
                }
            })
            .catch(error => {
                reject("Some Error occoured");
            })
    })
};


export { getCCPMetaData };